import * as Yup from "yup";

const trimRequired = (fieldName: string) =>
  Yup.string()
    .transform((value) => (typeof value === "string" ? value.trim() : value))
    .required(`${fieldName} is required`)
    .test(
      "not-empty-after-trim",
      `${fieldName} is required`,
      (value) => !!value && value.trim().length > 0
    );

    const nameRegex = /^[A-Za-z]+$/;
    
const validationSchema = Yup.object({
  dealNo: trimRequired("Deal No"),
  firstName: trimRequired("First Name").matches(
    nameRegex,
    "First Name is required"
  ),
  LastName: trimRequired("Last Name").matches(
    nameRegex,
    "Last Name is required"
  ),
  dealSource: trimRequired("Deal Source").matches(
    nameRegex,
    "DealSource is required"
  ),
  dealPartner: trimRequired("Deal Partner").matches(
    nameRegex,
    "DealPartner is required"
  ),
  dealCustomer: trimRequired("Deal Customer").matches(
    nameRegex,
    "DealCustomer is required"
  ),
  dealstatus: trimRequired("Deal Status"),
  dealStage: trimRequired("Deal Stage"),
  opportunityReceivedDate: Yup.date()
    .typeError("Invalid date")
    .required("Opportunity Received Date is required"),
  expectedClosureDate: Yup.date()
    .typeError("Invalid date")
    .required("Expected Closure Date is required"),
  dealTitle: trimRequired("Deal Title"),
  winProbability: Yup.number()
    .transform((value) => (isNaN(value) ? undefined : value))
    .typeError("Win Probability must be a number")
    .required("Win Probability is required")
    .min(0, "Must be at least 0")
    .max(100, "Cannot exceed 100"),
  dealTCV: Yup.number()
    .transform((value) => (isNaN(value) ? undefined : value))
    .typeError("Deal TCV must be a number")
    .required("Deal TCV is required")
    .min(0, "Must be at least 0"),
  dealCurrency: trimRequired("Currency"),
  dealType: trimRequired("Deal Type"),
  dealDurationMonths: Yup.number()
    .transform((value) => (isNaN(value) ? undefined : value))
    .typeError("Duration must be a number")
    .required("Duration is required"),
  lastUpdatedOn: Yup.date()
    .typeError("Invalid date")
    .required("Last Updated On is required"),
  lastUpdateRemarks: trimRequired("Remarks"),
});

export default validationSchema;
